import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes';
import { Toaster } from './components/ui';
import ScrollToTop from './components/ScrollToTop';
import SplashRenderer from './components/SplashScreens/SplashRenderer';
import Loader from './components/Loader';
import { useAuth } from './contexts/AuthContext';

function AppContent() {
  const { loading } = useAuth();

  // Show loader during initial authentication check
  if (loading) {
    return <Loader fullScreen/>;
  }

  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<Loader fullScreen />}>
        <AppRoutes />
      </Suspense>
      <Toaster position="top-right" />
      <SplashRenderer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
